var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgContact = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8916 17.4417L10.7333 19.6C10.2783 20.055 9.55492 20.055 9.08825 19.6117C8.95992 19.4833 8.83159 19.3667 8.70325 19.2383C7.50159 18.025 6.41659 16.7533 5.44825 15.4233C4.49159 14.0933 3.72159 12.7633 3.16159 11.445C2.61325 10.115 2.33325 8.84334 2.33325 7.63001C2.33325 6.83668 2.47325 6.07834 2.75325 5.37834C3.03325 4.66668 3.47659 4.01334 4.09492 3.43001C4.84159 2.69501 5.65825 2.33334 6.52159 2.33334C6.84825 2.33334 7.17492 2.40334 7.46659 2.54334C7.76992 2.68334 8.03825 2.89334 8.24825 3.19668L10.9549 7.01168C11.1649 7.30334 11.3166 7.57168 11.4216 7.82834C11.5266 8.07334 11.5849 8.31834 11.5849 8.54001C11.5849 8.82001 11.5033 9.10001 11.3399 9.36834C11.1883 9.63668 10.9666 9.91668 10.6866 10.1967L9.79992 11.1183C9.67159 11.2467 9.61325 11.3983 9.61325 11.585C9.61325 11.6783 9.62492 11.76 9.64825 11.8533C9.68325 11.9467 9.71825 12.0167 9.74159 12.0867C9.95159 12.4717 10.3133 12.9733 10.8266 13.58C11.3516 14.1867 11.9116 14.805 12.5183 15.4233C12.6349 15.54 12.7633 15.6567 12.8799 15.7733C13.3466 16.2283 13.3583 16.975 12.8916 17.4417Z",
    fill: "url(#paint0_linear_640_6511)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6319 21.385C25.6319 21.7117 25.5735 22.05 25.4569 22.3767C25.4219 22.47 25.3869 22.5633 25.3402 22.6567C25.1419 23.0767 24.8852 23.4733 24.5469 23.8467C23.9752 24.4767 23.3452 24.9317 22.6335 25.2233C22.6219 25.2233 22.6102 25.235 22.5985 25.235C21.9102 25.515 21.1635 25.6667 20.3585 25.6667C19.1685 25.6667 17.8969 25.3867 16.5552 24.815C15.2135 24.2433 13.8719 23.4733 12.5419 22.505C12.0869 22.1667 11.6319 21.8283 11.2002 21.4667L15.0152 17.6517C15.3419 17.8967 15.6335 18.0833 15.8785 18.2117C15.9369 18.235 16.0069 18.27 16.0885 18.305C16.1819 18.34 16.2752 18.3517 16.3802 18.3517C16.5785 18.3517 16.7302 18.2817 16.8585 18.1533L17.7452 17.2783C18.0369 16.9867 18.3169 16.765 18.5852 16.625C18.8535 16.4617 19.1219 16.38 19.4135 16.38C19.6352 16.38 19.8685 16.4267 20.1252 16.5317C20.3819 16.6367 20.6502 16.7883 20.9419 16.9867L24.8035 19.7283C25.1069 19.9383 25.3169 20.1833 25.4452 20.475C25.5619 20.7667 25.6319 21.0583 25.6319 21.385Z",
    fill: "url(#paint1_linear_640_6511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_6511",
    x1: 2.33325,
    y1: 9.81733,
    x2: 13.2358,
    y2: 9.81733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_6511",
    x1: 11.2002,
    y1: 20.3268,
    x2: 25.6319,
    y2: 20.3268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContact, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact.db5e7d2f.svg";
export { ForwardRef as ReactComponent };